import * as React from 'react';
// mui
import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography
} from '@mui/material';
// icons
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FlagIcon from '@mui/icons-material/Flag';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import NotesIcon from '@mui/icons-material/Notes';
import { convertEnergyToString, convertPriorityToString, convertTimeToMinutesString } from '../common/propertyValueToString';

// Props type
interface ReadOnlyTaskItemProps {
  title: string;
  completed: boolean;
  dueDate?: string;
  priority: number;
  energy: number;
  time: number;
  project?: string;
  subtasksCompleted: number;
  totalSubtasks: number;
  description?: string;
}

// Simplified due date formatter
const formatDueDate = (dateString: string, completed: boolean): React.ReactNode => {
  let label = dateString;
  let color = '';

  if (dateString === 'Today') {
    color = '#556cd6';
  } else if (dateString === 'Tomorrow') {
    color = '#7986cb';
  } else if (dateString === 'Yesterday') {
    color = '#ff7961';
  }

  if (completed) color = '';

  return (
    <>
      <CalendarTodayIcon sx={{ height: 16, width: 16, mb: '-3px', ml: 1, mr: '4px' }} />
      <span style={{ color }}>{label}</span>
    </>
  );
};

export default function ReadOnlyTaskItem({
  title,
  completed,
  dueDate,
  priority,
  energy,
  time,
  project,
  subtasksCompleted,
  totalSubtasks,
  description
}: ReadOnlyTaskItemProps) {
  return (
    <ListItem sx={{ pl: 2 }}>
      <ListItemIcon sx={{ minWidth: 36 }}>
        <KeyboardArrowRightIcon />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography sx={{ color: completed ? 'grey' : 'lightgrey' }}>{title}</Typography>
        }
        secondary={
          <Typography fontSize="small" sx={{ color: completed ? 'grey' : '#9e9e9e' }}>
            {totalSubtasks > 0 && (
              <>
                <SubdirectoryArrowRightIcon sx={{ height: 18, width: 18, mb: '-4px' }} />
                {`${subtasksCompleted}/${totalSubtasks}`}
              </>
            )}
            {description && (
              <NotesIcon sx={{ height: 18, width: 20, mb: '-4px', ml: totalSubtasks > 0 ? 1 : 0, mr: 0.5 }} />
            )}
            {dueDate && formatDueDate(dueDate, completed)}
            <FlagIcon sx={{ height: 18, width: 20, mb: '-4px', ml: 1 }} />
            {convertPriorityToString(priority)}
            <ElectricBoltIcon sx={{ height: 18, width: 20, mb: '-4px', ml: 1 }} />
            {convertEnergyToString(energy)}
            <AccessAlarmIcon sx={{ height: 18, width: 20, mb: '-4px', ml: 1 }} />
            {convertTimeToMinutesString(time)}
            {project && (
              <>
                <LocalOfferIcon sx={{ height: 18, width: 20, mb: '-4px', ml: 1 }} />
                {project}
              </>
            )}
          </Typography>
        }
      />
    </ListItem>
  );
}